<article>
  <div class="mobile-menu">
    <div class="menu-header">
      <div>
        <img src="https://4d-org-logos.s3.eu-west-2.amazonaws.com/{{ user().org.settings.theme_logo }}" alt="logo" />
      </div>
      <div>
        <app-button (click)="click('login')" label="Logout" />
      </div>
      <div>
        <i (click)="onMenuClick.emit(null)" class="mdi mdi-window-close"></i>
      </div>
    </div>
    <div class="menu-items">
      @if (!_isRestricted() && moduleAccess) {
        <div (click)="click('dashboard')">Dashboard</div>

        @if (moduleAccess?.issue_tracking) {
          <div (click)="click('issues')">Issue Tracking</div>
        }

        @if (moduleAccess?.organisation) {
          <div (click)="click('org')">Org</div>
        }
        @if (moduleAccess?.reports) {
          <div (click)="click('reports')">Reports</div>
        }
        @if (moduleAccess?.live) {
          <div (click)="click('live')">Live Feed</div>
        }
        @if (moduleAccess?.footfall) {
          <div (click)="click('footfall')">Footfall</div>
        }
        @if (moduleAccess?.training) {
          <div (click)="click('training')">Training</div>
        }
        @if (moduleAccess?.engagement) {
          <div (click)="click('engagement')">Engagement</div>
        }
        @if (moduleAccess?.partnership_engagement) {
          <div (click)="click('engage')">Engagement</div>
        }
        @if (moduleAccess?.camera) {
          <div (click)="click('camera')">Camera</div>
        }
        @if (moduleAccess?.energy) {
          <div (click)="click('energy')">Energy</div>
        }
        @if (moduleAccess?.insights) {
          <div (click)="click('insights')">Insights</div>
        }
        @if (moduleAccess?.admin) {
          <div (click)="click('admin')">Admin</div>
        }
        <div (click)="click('profile')">Your Account</div>
      } @else {
        @if (_isRestricted()) {
          @if (user.modules.has('Profiling')) {
            <div (click)="click('profiling')"><i class="fa fa-fw fa-building-o"></i> Floorplans</div>
          }

          @if (user.modules.has('Billing')) {
            <div (click)="click('org')"><i class="fa fa-fw fa-wifi"></i> Billing</div>
          }
          @if (user.modules.has('Live')) {
            <div (click)="click('live')"><i class="fa fa-fw fa-area-chart"></i> Live Feed</div>
          }

          <div (click)="click('profile')"><i class="fa fa-fw fa-user-circle-o"></i> Your Account</div>
        }
      }
    </div>
  </div>
</article>
